import { wrapperColor} from '../enums/rauchprotokoll.enum';
import { cigarWrapper } from "./cigar_wrapper";
import { CigarPhoto } from './cigar_photo';
import { HumidorEntry } from './humidor_entry';
import { Aroma } from './aroma';
import { Drink } from './drink';
export class smokingProtocol{
  humEntry:HumidorEntry;
  activeStep:number;
  photo:CigarPhoto|boolean=false;
  smokingLocation:string="outdoor"; //outdoor || indoor
  cut:string="double"; //wie wurde angeschnitten? double, drill, v-cut, scissors, none
  taste: Aroma[]=[]; //mehrere Geschmacksnuancen
  beverage:Drink;// was wurde dazu getrunken?
  beverage_fitted:number=0;//0 neutral, 1 nein, 2 ja
  cigarWrapper:cigarWrapper={
    color:wrapperColor.claro,
    structure:"fine",
    comments:"",
    rating:0 //0-15 Punkte
  };
  alerts=[];//{type:Tunnelbrand oder Schiefbrand, time: Minute in der der Alarm aufgetreten ist}
  smokingTime:number=0; //komplette Rauchzeit
  startedSmokingAt:number=null;//Unix-Time-Stamp ms seit 1970
  pausedAt:number=null;//Unix-Time-Stamp ms seit 1970
  pausedTime:number=0;//Sekunden
  status:string="started";//started (initial), running, paused
  cigarDrawRating:number=0; //0-5 Punkte
  cigarBurnRating:number=0; //0-5 Punkte
  cigarAshesRating:number=0; //0-5 Punkte
  cigarTasteRating:number=0; //0-70 Punkte
  ratingComplete:number=this.cigarTasteRating+this.cigarAshesRating+this.cigarBurnRating+this.cigarDrawRating+this.cigarWrapper.rating;
  cigarStrengthRating:number=0;
  conclusion:string="";
  rpg:number=0.00;//Rauchzeit pro EUR/Dollar/etc
  constructor(humEntry:HumidorEntry,activeStep:number=0){
    this.humEntry=humEntry;
    this.activeStep=activeStep;
  }
}
